import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  PostFormData,
  Put,
} from "../../../services/apiMethod";
import { AmenitiesEndpoints } from "./AmenitiesEndpoints";

export const getAmenityDetails = (param = "") => {
  const url = getAPIUrl(AmenitiesEndpoints.getAmenityDetails, param);
  return Get(url);
};

export const addAmenities = (data, param = "") => {
  const url = getAPIUrl(AmenitiesEndpoints.addAmenities, param);
  return PostFormData(url, data, true);
};
export const editAmenities = (data, param = "") => {
  const url = getAPIUrl(AmenitiesEndpoints.editAmenities, param);
  return PostFormData(url, data, true);
};
export const updateRequestStatus = (data, param = "") => {
  const url = getAPIUrl(AmenitiesEndpoints.updateRequestStatus, param);
  return Put(url, data);
};
export const deleteAminity = (param = "") => {
  const url = getAPIUrl(AmenitiesEndpoints.deleteAminity, param);
  return Delete(url, param);
};
